import {
  createVendorOrder,
  getVendorOrder,
  getVendorOrders,
  ICreateVendorOrderParams,
  IGetVendorOrderParams,
  IGetVendorOrdersParams,
  IVendorOrderCreateResponse,
  IVendorOrdersResponse
} from '@/api/vendorApplicationsApi';
import { getErrorData, IErrorData } from '@/utils/getErrorData';
import { isError } from '@/utils/typeguards/isError';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createVendorOrderThunk = createAsyncThunk<
  IVendorOrderCreateResponse,
  ICreateVendorOrderParams,
  { rejectValue: IErrorData }
>(
  'vendorApplications/createVendorOrderThunk',
  async (params, { rejectWithValue, signal }) => {
    try {
      const data = await createVendorOrder({
        ...params,
        signal
      });

      if (data === 'Abort') {
        return rejectWithValue({ message: 'Запрос был отменен' });
      }

      if (isError(data)) {
        return rejectWithValue(data);
      }

      if (data.response === null) {
        return rejectWithValue({ message: 'Некорректный ответ сервера' });
      }

      return data.response;
    } catch (error) {
      const errorData = getErrorData(error);
      return rejectWithValue(errorData);
    }
  }
);

export const getVendorOrdersThunk = createAsyncThunk<
  IVendorOrdersResponse,
  IGetVendorOrdersParams,
  { rejectValue: IErrorData }
>(
  'vendorApplications/getVendorOrdersThunk',
  async (params, { rejectWithValue, signal }) => {
    try {
      const data = await getVendorOrders({
        ...params,
        signal
      });

      if (data === 'Abort') {
        return rejectWithValue({ message: 'Запрос был отменен' });
      }

      if (isError(data)) {
        return rejectWithValue(data);
      }

      if (data.response === null) {
        return rejectWithValue({ message: 'Некорректный ответ сервера' });
      }

      return data.response;
    } catch (error) {
      const errorData = getErrorData(error);
      return rejectWithValue(errorData);
    }
  }
);

export const getVendorOrderThunk = createAsyncThunk<
  IVendorOrderCreateResponse,
  IGetVendorOrderParams,
  { rejectValue: IErrorData }
>(
  'vendorApplications/getVendorOrderThunk',
  async (params, { rejectWithValue, signal }) => {
    try {
      const data = await getVendorOrder({
        ...params,
        signal
      });

      if (data === 'Abort') {
        return rejectWithValue({ message: 'Запрос был отменен' });
      }

      if (isError(data)) {
        return rejectWithValue(data);
      }

      if (data.response === null) {
        return rejectWithValue({ message: 'Некорректный ответ сервера' });
      }

      return data.response;
    } catch (error) {
      const errorData = getErrorData(error);
      return rejectWithValue(errorData);
    }
  }
);
